import { render, staticRenderFns } from "./DrogMoreInformation.vue?vue&type=template&id=6080ceb7&scoped=true&"
import script from "./DrogMoreInformation.vue?vue&type=script&lang=js&"
export * from "./DrogMoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./DrogMoreInformation.vue?vue&type=style&index=0&id=6080ceb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080ceb7",
  null
  
)

export default component.exports